import { Expose } from "class-transformer";
import CastRes from "./CastRes";

export default class LoginRes {
  @Expose() readonly accessToken!: string;
  @Expose() readonly cast!: CastRes;
}
